import { createAsyncThunk } from '@reduxjs/toolkit';

import { get } from './http';
import { activeSnack } from '../store/common';

export const getAllReferrals = createAsyncThunk(
  'referral/list',
  async ({ page, search, limit, dispatch }) => {
    try {
      const response = await get(
        `member/refferals?page=${page && page}&search=${search && search}&limit=${limit || 5}`
      );
      console.log(response);
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
